import { useEffect, useState } from "react";
import "./Preloader.css";

// Home-refresh-only preloader. Mounted once at the App root (NOT in PageShell,
// which re-mounts per route), and only shown when the app initially loads on
// the homepage. Inner-page refreshes and in-app route changes skip it.
//
// Timing: ~1.3s total. Long enough to read as an intentional, premium beat;
// short enough to never feel like a wait. Sequence:
//   0ms    mark + rail fade/scale in
//   150ms  progress rail starts filling
//   1050ms rail reaches full, mark holds
//   1150ms whole overlay fades + lifts, unmounts after the transition
//
const HOLD_MS = 1500;   // time the loader stays fully visible
const FADE_MS = 480;    // exit transition duration

export default function Preloader() {
  const [phase, setPhase] = useState(() => {
    if (typeof window === "undefined") return "done";
    return window.location.pathname === "/" ? "in" : "done";
  });

  useEffect(() => {
    if (phase === "done") return undefined;

    const reduce =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      setPhase("done");
      return undefined;
    }

    const t1 = setTimeout(() => setPhase("out"), HOLD_MS);
    const t2 = setTimeout(() => setPhase("done"), HOLD_MS + FADE_MS);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [phase]);

  if (phase === "done") return null;

  return (
    <div
      className={`nr-preloader ${phase === "out" ? "is-leaving" : ""}`}
      role="status"
      aria-label="Loading Nausiddhi Realty"
    >
      <div className="nr-preloader__mark">
        <img src="/brand/logo-full.png" alt="" className="nr-preloader__logo" />
      </div>
      <div className="nr-preloader__rail">
        <span className="nr-preloader__rail-fill" />
      </div>
    </div>
  );
}
